module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-1500-Classes-Inactive-297cb3a65b6e87e1028db8bfaf989dcc.png";